<template>
  <v-container fluid class="icons-page">
    <v-row no-gutters class="d-flex justify-space-between mt-2 mb-2">
      <v-col>
        <!-- List -->
        <Table
          newItemLabel="All Enquiry"
          :filter="filter"
          :title="title"
          :api="api"
          :create="create"
          :del="del"
          :show="show"
          :resend="resend"
          :pay="pay"
          :edit="edit"
          :block="block"
          :headers="headers"
          @openFormPay="setFormPay"
        ></Table>
        <!-- Form -->
      </v-col>
    </v-row>

    <v-dialog v-model="dialog_pay_form" max-width="450px">
      <ConfirmBankForm
        v-if="dialog_pay_form"
        newItemLabel="Confirm Islamic Bank Order"
        :isNew="isNew"
        :api="api"
        :page="page"
        @dialogForm="dialog_pay_form = false"
        
      ></ConfirmBankForm>
    </v-dialog>
    
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      isNew: true,
      dialog_form: false,
      dialog_pay_form: false,
      page: 1,

      filter: "bank",
      api: {
        filter: "bank-enquiry",
        getAll: "bank-enquiry",
        show: "bank-order/",
        resend: "Islamic/PayButNotReceive",
        block: "block_order",
        type: "BANK",
        pay: "Islamic/make_as_pay"
      },
      create: false,
      pay: true,
      del: false,
      edit: false,
      show: true,
      resend: true,
      block: true,
      title: "all bills",
      fields: [
        {
          name: "الحجم",
          key: "size",
        },
        {
          name: "السعر",
          key: "price",
        },
      ],
      headers: [
        {
          text: "#",
          align: "start",
          sortable: true,
          value: "id",
        },
        {
          text: "actions",
          value: "actions",
        },
        {
          text: "",
          value: "operation",
          sortable: false,
        },
        {
          text: "response",
          value: "bank_response.result",
        },
        {
          text: "bank",
          value: "bank.name_ar",
        },
        {
          text: "customer id",
          value: "customer_id",
        },
        {
          text: "code",
          value: "code",
        },
        {
          text: "status",
          value: "status_response",
        },
        {
          text: "bank response",
          value: "bank_result",
        },
        {
          text: "amount",
          value: "amount",
        },
        {
          text: "amount currency",
          value: "amount_currency",
        },
        {
          text: "PayPal Account",
          value: "paypal_name",
        },{
          text: "payment method",
          value: "payment_method",
        },
        {
          text: "currency",
          value: "currency",
        },
        {
          text: "created_at",
          value: "created_at",
        },
        ,
      ],
    };
  },
  methods: {
    setForm(val) {
      let form = {
        size: null,
        price: null,
      };
      this.$store.dispatch("initForm", form);
      if (val != null) {
        this.isNew = false;
        this.$store.dispatch("setForm", val);
      } else {
        this.isNew = true;
      }
      this.dialog_form = true;
    },
    setFormPay(val) {

      this.dialog_pay_form = true;

      console.log(val);
      let form = {
        id: null,
        customer_id: null,
        provider: null,
        telephone: null,
        response: null,
        status: null,
      };
      this.$store.dispatch("initForm", form);
      if (val != null) {
        this.isNew = false;
        this.$store.dispatch("setForm", val);
      } else {
        this.isNew = true;
      }
      this.dialog_pay_form = true;

    },
  },
  //  mounted() {
  //   this.$store.dispatch('initForm', this.form)
  //  }
};
</script>
